<template>
  <div></div>
</template>

<script>
import InterviewsService from "@/services/InterviewsService";

export default {
  name: "preview",

  mounted() {
    InterviewsService.preview(this.$route.params.id).then(() => {
      this.$router.push({
        name: "interview",
        params: { keyword: "pre", p: 0, q: 0 }
      });
    });
  }
};
</script>
